import { useEffect } from "react";

export const useClickOutside = (onClickOutside, refs) => {
    useEffect(() => {
        const onClickOutsideEvent = event => {
            const isInsideAnyRef = refs.some(ref => ref?.current?.contains(event.target));
            if (!isInsideAnyRef) {
                onClickOutside(event);
            }
        };
        document.addEventListener("pointerdown", onClickOutsideEvent, true);
        return () => document.removeEventListener("pointerdown", onClickOutsideEvent, true);
    }, [onClickOutside, refs]);
};
